var scope_0 = require('/home/tnewsome/casualhacker/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/61ba444c6e5d0e190b13779192775585.js').default;
var scope_1 = require('/home/tnewsome/casualhacker/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca65e1b977d3f1a5f4a5edeb208414a1.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    